import {
	Datagrid,
	EditButton,
	Filter,
	List,
	ShowButton,
	TextField,
	TextInput,
	BooleanField,
	usePermissions,
} from "react-admin";
import { constants, rolesGlobal } from "../../utils/constants";
import React, { useMemo } from "react";
import { userPreferences } from "../../utils/fakeUserPrefrences";
import { CustomDeleteButtonWithCustomConfirm } from "../../customComponents/CustomButtons";

const BadgeFilter = (props) => (
	<Filter {...props}>
		<TextInput source="search" alwaysOn />
	</Filter>
);

export const TimelineList = (props) => {
	const defaultLocale = useMemo(
		() => userPreferences.defaultTranslationLanguage,
		[]
	);
	const { permissions, isLoading } = usePermissions();
	if (isLoading) return null;
	const hideActions = permissions?.includes(rolesGlobal.coach);
	return (
		<List
			{...props}
			perPage={constants.perPage}
			bulkActionButtons={false}
			filters={<BadgeFilter />}
		>
			<Datagrid>
				<TextField source={`name.${defaultLocale}`} sortable={false} />
				<BooleanField
					source="isChallenge"
					label="Challenge"
					sortable={false}
					looseValue={true}
				/>
				{hideActions === false ? (<EditButton />) : null}
				<ShowButton />
				{hideActions === false ? (<CustomDeleteButtonWithCustomConfirm mutationMode="pessimistic" />) : null}
			</Datagrid>
		</List>
	);
};

export default TimelineList;
